/* ART Global adapters v1.0.0 — LDO theme integration */
(() => {
  function applyCommercialStatus(select) {
    const niceSelect = select.nextElementSibling;
    if (!niceSelect?.classList.contains('nice-select')) return;

    const list = niceSelect.querySelector('ul.nice-list');
    if (!list) return;

    select.querySelectorAll('option[data-commercial-status]').forEach((option) => {
      const status = option.dataset.commercialStatus;
      if (status !== 'Discontinued' && status !== 'Blocked') return;

      const item = niceSelect.querySelector(`li.option[data-value="${CSS.escape(option.value)}"]`);
      item?.classList.add('option--discontinued');
    });

    const items = Array.from(list.querySelectorAll('li.option'));
    items.sort((left, right) => {
      const leftUnavailable = left.classList.contains('option--discontinued') ? 1 : 0;
      const rightUnavailable = right.classList.contains('option--discontinued') ? 1 : 0;
      return leftUnavailable - rightUnavailable;
    });
    items.forEach((item) => list.appendChild(item));
  }

  function decorateSelects(root = document) {
    root.querySelectorAll('select.nice__select').forEach(applyCommercialStatus);
  }

  const nativeRenderSelects = window.renderSelects;
  if (typeof nativeRenderSelects === 'function') {
    window.renderSelects = function renderArtSelects(...args) {
      const result = nativeRenderSelects.apply(this, args);
      decorateSelects();
      return result;
    };
  }

  document.addEventListener('DOMContentLoaded', () => decorateSelects());
  document.addEventListener('shopify:section:load', (event) => decorateSelects(event.target));

  customElements.whenDefined('slider-component').then(() => {
    const SliderComponent = customElements.get('slider-component');
    const nativeIsSlideVisible = SliderComponent?.prototype?.isSlideVisible;
    if (!nativeIsSlideVisible || nativeIsSlideVisible.artGuarded) return;

    function isArtSlideVisible(element, offset = 0) {
      if (this._layoutMode === 'wrapped' && !this.sliderItemsToShow?.[0]) return false;
      return nativeIsSlideVisible.call(this, element, offset);
    }

    isArtSlideVisible.artGuarded = true;
    SliderComponent.prototype.isSlideVisible = isArtSlideVisible;
  });
})();
